import initialState from './initialState'
import { initFamilies } from './helpers'
const resetState = async ({ commit }) => {
    var payload = initialState()
    payload.families = await initFamilies()
    commit('RESET_STATE', payload)
}

export default {
    resetState,
}
